import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { NAV } from "../../data/site";
import { useTheme } from "../../hooks/useTheme";

// Sticky 68px header. No logo or identity mark: the centred nav and the theme
// button are the whole of it. Below 700px the nav becomes a typographic
// disclosure list rather than wrapping and breaking the header height.
const Header = () => {
	const { theme, toggleTheme } = useTheme();
	const { pathname } = useLocation();
	const [menuOpen, setMenuOpen] = useState(false);

	useEffect(() => {
		setMenuOpen(false);
	}, [pathname]);

	// The label is the theme you would switch to.
	const themeLabel = theme === "dark" ? "Light" : "Dark";

	return (
		<header className="site-header">
			<div className="header-inner">
				<div className="header-spacer" />
				<button
					type="button"
					className="menu-btn"
					aria-expanded={menuOpen}
					aria-controls="mobile-nav"
					onClick={() => setMenuOpen((open) => !open)}
				>
					{menuOpen ? "Close" : "Menu"}
				</button>
				<nav className="site-nav" aria-label="Primary">
					{NAV.map((item) => (
						<NavLink
							key={item.path}
							to={item.path}
							end={item.path === "/"}
							className={({ isActive }) =>
								"nav-item" + (isActive ? " is-active" : "")
							}
						>
							{item.label}
						</NavLink>
					))}
				</nav>
				<button
					type="button"
					className="theme-btn"
					onClick={toggleTheme}
					aria-label={"Switch to " + themeLabel.toLowerCase() + " theme"}
					title={"Switch to " + themeLabel.toLowerCase() + " theme"}
				>
					{themeLabel}
				</button>
			</div>

			{menuOpen && (
				// Entrance is a CSS animation rather than a Framer height
				// tween: the panel stays visible even if the animation never
				// runs, and reduced motion drops it cleanly.
				<div id="mobile-nav" className="mobile-nav">
					<nav className="wrap" aria-label="Primary, mobile">
						{NAV.map((item) => (
							<NavLink
								key={item.path}
								to={item.path}
								end={item.path === "/"}
								className={({ isActive }) =>
									"mobile-nav-item" +
									(isActive ? " is-active" : "")
								}
							>
								{item.label}
							</NavLink>
						))}
					</nav>
				</div>
			)}
		</header>
	);
};

export default Header;
